import { findBand, BAND_COLORS } from "../bands";

// DAPSA28 — Disease Activity in PSoriatic Arthritis using 28-joint counts.
// ⚠️ DAPSA28 is a less-established variant: its exact formula, CRP-unit handling
// and cut-offs are NOT as well validated as DAPSA66/68. CRP is entered here in mg/L
// and converted to mg/dL (÷10) for the linear sum (the DAPSA formula uses mg/dL).
// Confirm the formula, the CRP unit handling, and the bands clinically before use.
const dapsa28Bands = [
    { label: "Remission", color: BAND_COLORS.remission, lte: 4 },
    { label: "Low", color: BAND_COLORS.low, lte: 14 },
    { label: "Moderate", color: BAND_COLORS.moderate, lte: 28 },
    { label: "High", color: BAND_COLORS.high },
];

export const dapsa28 = {
    id: "dapsa28",
    name: "DAPSA28",
    subtitle: "Disease activity index for psoriatic arthritis 28",
    group: "Psoriatic arthritis",
    status: "ready",
    options: [],
    fields: [
        { key: "sjc28", label: "Swollen joint count (0–28)", unit: "joints", type: "number", min: 0, max: 28 },
        { key: "tjc28", label: "Tender joint count (0–28)", unit: "joints", type: "number", min: 0, max: 28 },
        {
            key: "pain",
            label: "Patient's pain assessment (PP)",
            unit: "cm",
            hint: "Visual analogue scale (VAS)",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "ptga",
            label: "Patient's global assessment (PtGA)",
            unit: "cm",
            hint: "Visual analogue scale (VAS)",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "crp",
            label: "C-reactive protein (CRP)",
            unit: "mg/L",
            type: "number",
            min: 0,
            max: 500,
            step: 0.1,
        },
    ],
    // CRP entered in mg/L, converted to mg/dL (÷10) for the DAPSA linear sum.
    compute: (v) => v.sjc28 + v.tjc28 + v.pain + v.ptga + v.crp / 10,
    interpret: (score) => findBand(score, dapsa28Bands),
    bands: () => dapsa28Bands,
    about:
        "DAPSA28 applies the Disease Activity in PSoriatic Arthritis (DAPSA) approach using 28-joint counts. It is the linear sum of the swollen and tender joint counts (0–28 each), the patient's pain and global assessments (0–10 cm VAS each) and CRP. The score categorises disease activity into remission, low, moderate or high.",
    references: [
        "Schoels M, et al. Application of the DAREA/DAPSA score for assessment of disease activity in psoriatic arthritis. Ann Rheum Dis. 2010.",
    ],
};
